"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountType = void 0;
exports.accountIsEnterprise = accountIsEnterprise;
exports.accountIsOrganization = accountIsOrganization;
exports.accountIsUser = accountIsUser;
exports.createFollowerDocumentUid = createFollowerDocumentUid;
exports.createAccountFollowerData = createAccountFollowerData;
const zod_1 = require("zod");
const identifier_1 = require("./identifier");
exports.AccountType = zod_1.z.enum(["user", "organization", "enterprise"]);
function accountIsEnterprise(account) {
    return (0, identifier_1.isEnterpriseUid)(account.uid);
}
function accountIsOrganization(account) {
    return (0, identifier_1.isOrganizationUid)(account.uid);
}
function accountIsUser(account) {
    return !(0, identifier_1.isOrganizationUid)(account.uid) && !(0, identifier_1.isEnterpriseUid)(account.uid);
}
function createFollowerDocumentUid(followedUid, followerUid) {
    return `${followedUid}:${followerUid}`;
}
function createAccountFollowerData(followedUid, followedAccountType, followerUid, followerAccountType) {
    return {
        uid: createFollowerDocumentUid(followedUid, followerUid),
        created_at: new Date().getTime(),
        updated_at: new Date().getTime(),
        followed_uid: followedUid,
        followed_account_type: followedAccountType,
        follower_uid: followerUid,
        follower_uid_account_type: followerAccountType,
    };
}
//# sourceMappingURL=account.js.map